<style src="@wangeditor/editor/dist/css/style.css"></style>
<template>
  <div>
    <!-- SEARCH -->
    <Row>
      <Col span="24">
        <Card class="margin-bottom-10">
          <Form inline>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.fieldName' :placeholder="$t('玩法') "></Input>
            </FormItem>
            <FormItem class='margin-bottom-0'>
              <Input clearable v-model='searchConf.title' :placeholder="$t('默认标题') "></Input>
            </FormItem>
            <FormItem class="margin-bottom-0">
              <Button type="primary" @click="search">{{ $t("find_button") }}</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>        <!--    -->
    <Row>
      <Col span='24'>
        <Card>
          <!-- ADDBUTTON -->
          <div class='margin-bottom-15'>
            <Button type='primary' @click='preAdd' icon='md-add'>
              {{ $t('add_button') }}
            </Button>
          </div>
          <!-- DATA -->
          <div>
            <Table @on-sort-change="sortChange" :loading='listLoading' :columns='columnsList' :data='tableData'
                   border></Table>
          </div>
          <!-- PAGE -->
          <div class='margin-top-15' style='text-align: center'>
            <Page :total='tableShow.listCount' :current='tableShow.currentPage' :page-size='tableShow.pageSize'
                  @on-change='changePage' @on-page-size-change='changeSize'
                  :page-size-opts='[10,20,30,40,50,100,200,300]' show-elevator show-sizer show-total></Page>
          </div>
        </Card>
      </Col>
    </Row>
    <!-- windowAddEdit -->
    <Modal v-model="windowAdd.show" width="768" :styles="{top: '30px'}" @on-visible-change="windowAddCancel">
      <p slot="header" style="color:#2d8cf0">
        <Icon type="md-alert"></Icon>
        <span>{{ windowAddItem.id ? $t('编辑') : $t('新增') }}</span>
      </p>
      <Form ref="windowAddForm" :rules="windowAddValidate" :model="windowAddItem" :label-width="80"
            label-position="left">
        <FormItem label='玩法' prop='fieldName'>
          <Input clearable v-model='windowAddItem.fieldName' :placeholder="$t('请输入玩法名称')"></Input>
        </FormItem>
        <FormItem label='玩法默认标题' prop='title'>
          <Input clearable v-model='windowAddItem.title' :placeholder="$t('请输入玩法默认标题')"></Input>
        </FormItem>

        <FormItem label='生成方式' prop='generate'>
          <Input clearable v-model='windowAddItem.generate' :placeholder="$t('请输入生成方式')"></Input>
          <span> (1~10生成几个数字码)<br>
 (one-ten是生成几个生肖)<br>
  (ds 生成单双)<br>
(onecolor生成一个波色 \  twocolor生成两个波色  )<br>
(home_1~home_9 生成几只家禽 beast_1~beast_4 是几只野兽)<br>
(tail_0~tail_9 是几个尾数)<br>
 (jy 生成家禽或野兽)<br>
(he_1~he_13 合数中特)12合<br>
            (sx_1_3~sx_1_8 生肖带生肖号码)【鼠01】<br>
              (ds_1~ds_15 单数号码)<br>
            (ss_1~ss_15 双数号码)<br>

| 符号是多个选项时使用 如: 女肖|男肖<br>
+ 是多合一时使用的 如  二肖+二码可以用 two+2(非常方便,可以把各种玩法连接一起)<br>
 * 是多次生多个时使用  如:二行 可以用  金|木|水|火|土*2<br>
(有些玩法有 - 号连接 如 五肖主五码 five-5)<br>
</span>
        </FormItem>
        <FormItem label='内容是否杀肖' prop='isIn'>
          <Select clearable v-model='windowAddItem.isIn' style='width:200px'>
            <Option :value="'1'" :key='1'>{{ $t('否') }}</Option>
            <Option :value="'0'" :key='0'>{{ $t('是') }}</Option>
          </Select>
        </FormItem>
        <FormItem label='是否尾数' prop='isWs'>
          <Select clearable v-model='windowAddItem.isWs' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('否') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('是') }}</Option>
          </Select>
        </FormItem>
        <FormItem label='是否包含小码' prop='isAllNum'>
          <Select clearable v-model='windowAddItem.isAllNum' style='width:200px'>
            <Option :value="'0'" :key='0'>{{ $t('否') }}</Option>
            <Option :value="'1'" :key='1'>{{ $t('是') }}</Option>
          </Select>
        </FormItem>

        <FormItem style="margin-bottom:4px" label='玩法模板' prop='body'>
          <span> {$value['issue']} 期号<br>
 {$author}作者<br>
 {$title}标题<br>
{$value['code']}购买的内容<br>
{$value['open']}开奖结果 如:鼠01<br>
{$value['opened']}开奖内容 如: 金 <br>
{$value['isZhun']}是否准<br>
            特殊写法<br>
            {mb_substr($value['code'], 0, 4)}前4个生肖(内容是生肖)<br>
{mb_substr($value['code'], -4)} 后4个生肖(内容是生肖)<br>
            {implode('.', array_slice(explode('.', $value['code']), 0, 4))} 前4个号码(内容是号码);<br>
             {implode('.', array_slice(explode('.', $value['code']), -4))} 后4个号码(内容是号码);<br>
例子:{$value['issue']}期:{$author}◎{$title}┣{$value['code']}┫开:{$value['opened']}{$value['isZhun']}<br>
</span>
          <Button type="text" @click="isHtml=!isHtml" class="margin-left-10">{{
              $t('编辑源码')
            }}
          </Button>

          <div v-if="isHtml==false" style="border: 1px solid #ccc;">
            <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editor"
              :defaultConfig="toolbarConfig"
              :mode="mode"
            />
            <Editor
              style="height: 200px; overflow-y: hidden;"
              v-model="windowAddItem.template"
              :defaultConfig="editorConfig"
              :mode="mode"
              @onCreated="onCreated"
            />
          </div>
          <textarea v-if="isHtml==true" v-model="windowAddItem.template" name="ckeditor" rows="10" cols="88"></textarea>
          <!--          <textarea   v-if="isHtml==true" v-model="html"   style="height: 200px;weight:400px; overflow-y: hidden;" ></textarea>-->
        </FormItem>

        <FormItem style="margin-bottom:4px" label='玩法说明' prop='body'>
          <Button type="text" @click="isHtml2=!isHtml2" class="margin-left-10">{{
              $t('编辑源码')
            }}
          </Button>

          <div v-if="isHtml2==false" style="border: 1px solid #ccc;">
            <Toolbar
              style="border-bottom: 1px solid #ccc"
              :editor="editor2"
              :defaultConfig="toolbarConfig"
              :mode="mode"
            />
            <Editor
              style="height: 200px; overflow-y: hidden;"
              v-model="windowAddItem.tip"
              :defaultConfig="editorConfig"
              :mode="mode"
              @onCreated="onCreated2"
            />
          </div>
          <textarea v-if="isHtml2==true" v-model="windowAddItem.tip" name="ckeditor" rows="10" cols="88"></textarea>
          <!--          <textarea   v-if="isHtml==true" v-model="html"   style="height: 200px;weight:400px; overflow-y: hidden;" ></textarea>-->
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="windowAddCancel()" class="margin-right-10">{{ $t('取消') }}</Button>
        <Button type="primary" @click="windowAddSubmit" :loading="windowAdd.loading">{{ $t('确定') }}</Button>
      </div>
    </Modal>
    <!--    -->
  </div>
</template>
<script>
import {
  getList,
  add,
  del,
  lock,
  getParams,
  changeStatus
} from '@/api/LhcManage/LhcFielldBbs'
import {
  formattingMonth,
  lastMonthDate
} from '@/libs/time'
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'

export default {
  name: 'interface_list',
  components: {Editor, Toolbar},
  data() {
    return {
      editor: null,
      editor2: null,
      toolbarConfig: {},
      editorConfig: {placeholder: '请输入内容...'},
      mode: 'default', // or 'simple',
      isHtml: false,
      isHtml2: false,

      timeOptions: {
        shortcuts: [{
          text: '今天',
          value() {
            let a = new Date(new Date(new Date().toLocaleDateString()).getTime())
            let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
            return [a, b]
          }
        },
          {
            text: '昨天',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 + 24 * 60 *
                60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '一周',
            value() {
              let a = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000 * 7)
              let b = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              return [a, b]
            }
          },
          {
            text: '本月',
            value() {
              return formattingMonth()
            }
          },
          {
            text: '上月',
            value() {
              return lastMonthDate()
            }
          },
        ]
      },
      columnsList: [{
        title: this.$t('玩法'),
        key: 'fieldName',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('默认标题'),
        key: 'title',

        minWidth: 120,
        align: 'center'
      }, {
        title: this.$t('操作'),
        align: 'center',
        minWidth: 120,
        render: (h, params) => {
          let vm = this
          return h('div', [h('Button', {
            props: {
              type: 'primary'
            },
            style: {
              margin: '0 5px'
            },
            on: {
              'click': () => {
                let vm = this
                vm.windowAddItem['id'] = params.row.id;
                vm.windowAddItem['fieldName'] = params.row.fieldName;
                vm.windowAddItem['generate'] = params.row.generate;
                vm.windowAddItem['isIn'] = params.row.isIn.toString();
                vm.windowAddItem['isWs'] = params.row.isWs.toString();
                vm.windowAddItem['isAllNum'] = params.row.isAllNum.toString();
                vm.windowAddItem['title'] = params.row.title;

                vm.windowAddItem['template'] = params.row.template;
                vm.windowAddItem['tip'] = params.row.tip;

                vm.windowAdd.show = true
              }
            }
          }, this.$t('编辑玩法')),])
        }
      },],
      tableData: [],//用于放LIST数据绑定
      tableShow: { //用于分页
        currentPage: 1,
        pageSize: 10,
        listCount: 0
      },
      searchConf: {searchTime: [],}, // 搜索字段
      extraParams: [],
      buttonShow: { //按钮状态显示
        edit: true,
        del: true,
        changeStatus: true
      },
      listLoading: false, //显示加载中状态
      //弹窗--------------
      windowAdd: { //弹窗
        show: false,
        loading: false,
        index: 0
      },
      windowAddItem: { //弹窗数据绑定
        id: 0
      },
      windowAddValidate: {//窗口校验规则
      },                            //----------------
    }
  },
  created() {
    let vm = this
    vm.getList()
    vm.hasRule('LhcManage/LhcFielldBbs/edit').then(res => {
      vm.buttonShow.edit = res
    })
    vm.hasRule('LhcManage/LhcFielldBbs/del').then(res => {
      vm.buttonShow.del = res
    })
    vm.hasRule('LhcManage/LhcFielldBbs/changeStatus').then(res => {
      vm.buttonShow.changeStatus = res
    })
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor != null) editor.destroy()
    // 组件销毁时，及时销毁编辑器
    const editor2 = this.editor2
    if (editor2 != null) editor2.destroy()
    // 组件销毁时，及时销毁编辑器
  },

  mounted() {
    this.getParams()
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    onCreated2(editor2) {
      this.editor2 = Object.seal(editor2) // 一定要用 Object.seal() ，否则会报错
    },
    preAdd() {
      let vm = this
      vm.windowAddItem['id'] = 0;
      vm.windowAddItem['fieldName'] = '';
      vm.windowAddItem['generate'] = '';
      vm.windowAddItem['isIn'] = '1';
      vm.windowAddItem['isWs'] = '0';
      vm.windowAddItem['isAllNum'] = '0';
      vm.windowAddItem['title'] = '';

      vm.windowAddItem['template'] = '';
      vm.windowAddItem['tip'] = '';


      vm.windowAdd.show = true
    },
    getParams() {
      // getParams().then(response => {
      //     this.extraParams = response.data.data
      // })
    },
    changePage(page) {
      this.tableShow.currentPage = page
      this.getList()
    },
    changeSize(size) {
      this.tableShow.pageSize = size
      this.getList()
    },
    search() {
      this.tableShow.currentPage = 1
      this.getList()
    },
    getList() {
      let vm = this
      vm.listLoading = true
      getList({
        page: vm.tableShow.currentPage,
        size: vm.tableShow.pageSize,
        search: vm.searchConf
      }).then(response => {
        vm.tableData = response.data.data.list
        vm.tableShow.listCount = response.data.data.count
        vm.listLoading = false
      })
    },

    timeChange(datetimerange) { //时间修改，自动计算尾部时间
      if (datetimerange[0] !== '' && datetimerange[1] !== '') {
        let patt = /00:00:00/
        this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        if (patt.test(datetimerange[1])) {
          datetimerange[1] = datetimerange[1].replace('00:00:00', '23:59:59')
          this.searchConf.searchTime = [datetimerange[0], datetimerange[1]]
        }
      } else {
        this.searchConf.searchTime = []
      }
    },
    sortChange: function ({column, key, order}) {
      //order值可能为asc,desc,normal
      this.searchConf.order = [key, order]
      if (order == 'normal') {
        this.searchConf.order = []
      }
      this.getList()
    },
    windowAddCancel(data) {
      if (!data) {
        this.windowAddItem.id = 0
        this.$refs['windowAddForm'].resetFields()
        this.windowAdd.show = false
        this.windowAdd.loading = false
        this.windowAdd.index = 0
      }
    }, windowAddSubmit() {
      let vm = this
      vm.$refs['windowAddForm'].validate((valid) => {
        if (valid) {
          vm.windowAdd.loading = true
          add(vm.windowAddItem).then(response => {
            vm.$Message.success(response.data.msg)
            vm.getList()
            vm.windowAddCancel()
          }).catch(() => {
            vm.windowAdd.loading = false
          })
        }
      })
    },
  }
}
</script>
